export default __webpack_public_path__ + "static/media/co-photo.473773f7.jpeg";